import React from 'react';
import ReactDOM from 'react-dom';
import OKRHistoryComp from './components/okr-history';


function RenderOKRHistoryComp(props = {}, ele) {
  if (ele) {
    ReactDOM.unmountComponentAtNode(ele);
  }
  ReactDOM.render(<OKRHistoryComp {...props} />, ele);
}

window.RenderOKRHistoryComp = RenderOKRHistoryComp;
